import React from 'react'
import { checkTextTranslation, checkTranslation, getObject } from '../../utils/useful'
import ThirdPartyComponents from './ThirdParties'

class ThirdPartyInput extends React.Component {
    state = {
    }


    changeInputValue = (value) => {
        this.props.changeValue(this.props.header.key, value, this.props.extra)
    }

    componentDidMount() {
        // console.log('this.props.data', this.props?.data)
    }
    focus = () => {
        this.input.focus()
    }
    selectHandler = () => {

    }

    render() {
        let info = this.props.header?.information

        let refKey = info?.refKey

        let thirdparty = getObject(this.props.fullData, refKey)


        let Component

        if (thirdparty) {
            Component = ThirdPartyComponents[thirdparty]
        }


        return (
            <div className="w-100 h-100 flexc"  >

                {Component ? (
                    <Component header={this.props.header} changeInputValue={this.changeInputValue} fullData={this.props.fullData} data={this.props.data} variables={this.props.variables} />
                ) : (
                    <p>Third party not found!</p>

                )}
            </div>
        )
    }
}

export default ThirdPartyInput;